import { createSelector } from '@reduxjs/toolkit';
import { IState } from '..';
import { IInventoryItem, IInventoryRequest } from './inventoryInterfaces';

export const isInvetoryLoading = createSelector(
  [(state: IState) => state.inventory.loading, (_: unknown, request: IInventoryRequest) => request],
  (loading, request) => loading.includes(`${request.itemId}_${request.inventDimId}`)
);

export const getItemInventory = createSelector(
  [(state: IState) => state.inventory.hash, (_: unknown, request: IInventoryRequest) => request],
  (hash, request): IInventoryItem | undefined => hash[`${request.itemId}_${request.inventDimId}`]
);
